import { Outlet } from "react-router-dom"

export function AuthLayout() {
  return (
    <div
      className="relative flex min-h-screen items-center justify-center p-4 overflow-hidden bg-[var(--bg)]"
    >
      {/* Subtle grid pattern */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage:
            "linear-gradient(var(--foreground) 1px, transparent 1px), " +
            "linear-gradient(90deg, var(--foreground) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <div className="relative z-10 w-full max-w-[380px]">
        {/* Brand header */}
        <div className="mb-6 flex flex-col items-center gap-2.5">
          <div
            className="flex h-10 w-10 items-center justify-center rounded-lg text-base font-bold text-primary-foreground bg-primary"
          >
            O
          </div>
          <div className="text-center">
            <h1 className="text-xl font-semibold tracking-tight text-foreground">
              OkeyCRM
            </h1>
            <p className="mt-0.5 text-[13px] text-muted-foreground">
              System CRM dla Twojego biznesu
            </p>
          </div>
        </div>

        {/* Card */}
        <div className="rounded-lg border bg-[var(--bg-surface)] p-7">
          <Outlet />
        </div>

        {/* Footer */}
        <p className="mt-5 text-center text-[11px] text-muted-foreground">
          &copy; {new Date().getFullYear()} OkeyCRM. Wszelkie prawa zastrzezone.
        </p>
      </div>
    </div>
  )
}
